import { NextPage } from 'next';
import { getDataFromTree } from '@apollo/client/react/ssr';
// Hoc
import withApollo from 'hocs/withApollo';
// Helpers
import { getEnvLink } from 'helpers/routes';
// Context
import { FiltersProvider } from 'components/common3/PageWithFiltersWrapper/PageWithFiltersContext';
// Types
import { SortDirection, StoresOrderBy } from 'api/graphql-global-types';
// Layouts
import { generateCollectionPageStructuredData } from 'helpers/structured-data';
import Head from 'layouts/Head/Head';
import Header from 'layouts/Header/Header';
import Footer from 'layouts/Footer/Footer';
// Components
import CreatorsContainer from 'components/Creators/Creators';
import PageBanner from 'components/common3/PageBanner/PageBanner';

const Creators: NextPage = () => {
  const image = `${getEnvLink()}${'/gyms.jpg'}`;
  const bannerImage = `${getEnvLink()}${'/images/page-banner-images/talent.png'}`;

  return (
    <>
      <Head
        image={image}
        structuredData={generateCollectionPageStructuredData({
          name: 'Sports Creators',
          path: '/creators',
        })}
        title="MILLIONS Creators | Sports Streaming, Merch and Fan Engagement"
        description="Discover sports creators on MILLIONS. Watch live streams and PPVs, shop merch, book experiences, and connect through podcasts, videos, and fan communities."
      />

      <Header />
      <PageBanner title="Creators" imageUrl={bannerImage} />

      <FiltersProvider
        searchKey="searchTerm"
        hideStoreFilter={false}
        hideAthletesFilter
        hideOrganizationsFilter
        hideContentCreatorsFilter
        initialSorting={{
          direction: SortDirection.DESC,
          order: StoresOrderBy.socialFollowerCount,
        }}
      >
        <CreatorsContainer />
      </FiltersProvider>

      <Footer />
    </>
  );
};

export default withApollo(Creators, { getDataFromTree });
